<script>
import {disposeTooltipsByClass, getTooltipById, setupTooltipsByClass} from "@/libs/Helpers";

export default {
  emits: ['onSwitchChange'],
  props: {
    propId: String,
    propOptions: Array,
    propShowTooltip: {type: Boolean, default: false},
    propDisabled: {type: Boolean, default: false}
  },
  watch: {
    propShowTooltip(newValue, oldValue) {
      setTimeout(() => {
        this.showHide(newValue)
      }, 270);
    }
  },
  data() {
    let selectedItems = {};

    Object.keys(this.propOptions).forEach(key => {
      let optionItem = this.propOptions[key];
      selectedItems[optionItem.id] = optionItem.selected;
    })
    return {
      selected: selectedItems
    }
  },
  methods: {
    createTooltip() {
      let tooltipClass = `.${this.tooltipClass}`;
      disposeTooltipsByClass(tooltipClass);
      setupTooltipsByClass(tooltipClass);
    },
    showHide(status) {
      if (this.tooltipObject !== null) {
        if (status === true) {
          this.tooltipObject.show();
        } else if (status === false)
          this.tooltipObject.hide();
      }
    },
    onSwitchChange(optionId) {
      this.$emit('onSwitchChange', optionId, this.selected[optionId]);
    }
  },
  computed: {
    tooltipClass() {
      return `tooltip-${this.propId}`;
    },
    tooltipId() {
      return `tooltip-${this.propId}`;
    },
    tooltipObject() {
      return getTooltipById(this.tooltipId);
    }
  },
  mounted() {
    this.createTooltip();
  },
  updated() {
    this.createTooltip();
  },
  beforeUnmount() {
    this.showHide(false);
  }
}
</script>

<template>
  <div class="control-options">
    <div class="btn-group dropup"
         :id="tooltipId"
         :class="tooltipClass"
         data-bs-toggle="tooltip"
         data-bs-placement="right"
         :data-bs-title="$t('buttons.MapOptions')">
      <button type="button" class="btn btn-sm btn-dark dropdown-toggle"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              :disabled="propDisabled"
              aria-expanded="false">
        <i class="bi bi-map-fill me-2"/>
      </button>
      <div class="dropdown-menu p-2">
        <div class="row">
          <div class="col">
            <div class="form-check form-switch" v-for="option in propOptions">
              <input class="form-check-input" type="checkbox"
                     role="switch"
                     v-model="selected[option.id]"
                     :id="`switch_${propId}_${option.id}`"
                     @change="onSwitchChange(option.id)">
              <label class="form-check-label small" :for="`switch_${propId}_${option.id}`">
                {{ option.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>